/** Full roadmap timeline — shared by `Roadmap` and homepage RPG layout. */
export const ROADMAP_ITEMS = [
  {
    roadmapTitle: "Mid of Q1 2022",
    title: "Concept",
    info: [
      "Research proof of concept idea",
      "Consult various sources",
      "Information gathering stage",
    ],
  },
  {
    roadmapTitle: "Q2 2022",
    title: "Research",
    info: [
      "Forming a team to build idea",
      "Formulate active plan",
      "Set milestone goals to achieve",
    ],
  },
  {
    roadmapTitle: "Mid of Q3 2022",
    title: "Development",
    info: [
      "Continued team building",
      "Ongoing plan adaptation",
      "Assess and reassess road map",
    ],
  },
  {
    roadmapTitle: "Q4 2022",
    title: "Development",
    info: [
      "Onboarding new employees with training",
      "Bringing artists up to speed to implement designs",
      "Adaptation of ongoing plan",
    ],
  },
  {
    roadmapTitle: "Mid of Q1 2023",
    title: "Development",
    info: [
      "Whitepaper and prototype coin",
      "World building ongoing",
      "Story lore ongoing",
    ],
  },
  {
    roadmapTitle: "Q2 2023",
    title: "Development",
    info: [
      "Finalizing NFT comic book and story content",
      "Creation of Comic book hero NFT",
      "Social media marketing",
    ],
  },
  {
    roadmapTitle: "Q3 2023",
    title: "Development",
    info: ["Website and newsletter", "Blog, social media, PR release"],
  },
  {
    roadmapTitle: "Mid of Q4 2023",
    title: "Operational",
    info: [
      "World building unreal engine",
      "Continued marketing",
      "Ongoing research",
    ],
  },
  {
    roadmapTitle: "Mid of Q1 2024",
    title: "Operational",
    info: [
      "World building unreal engine",
      "Continued marketing",
      "Ongoing research",
    ],
  },
  {
    roadmapTitle: "Mid of Q2 2024",
    title: "Operational",
    info: [
      "World building unreal engine",
      "Continued marketing",
      "Ongoing research",
    ],
  },
  {
    roadmapTitle: "Mid of Q3 2024",
    title: "Operational",
    info: [
      "World building unreal engine",
      "Marketing pre city launch",
      "Increased community awareness",
    ],
  },
  {
    roadmapTitle: "Mid of Q1 2025",
    title: "Operational",
    info: [
      "World building unreal engine",
      "VR city building",
      "Educational VR set to launch",
      "Game ads, live presale for crypto",
    ],
  },
  {
    roadmapTitle: "Mid of Q2 2025",
    title: "Operational",
    info: [
      "World building unreal engine",
      "VR city building",
      "Educational VR live courses",
      "Continued presale",
      "Marketing steam",
    ],
  },
  {
    roadmapTitle: "Mid of Q3 2025",
    title: "Operational",
    info: ["Demo game", "Bug fixes", "Educational VR live"],
  },
  {
    roadmapTitle: "Mid of Q4 2025",
    title: "Operational",
    info: ["Game live sales", "Educational VR live"],
  },
];

/** Condensed “journey” milestones aligned with marketing mockup. */
export const ROADMAP_JOURNEY_HIGHLIGHTS = [
  {
    phase: "Q2 2024",
    title: "FOUNDATION",
    blurb: "Core lore, economy design, and token architecture.",
  },
  {
    phase: "Q4 2024",
    title: "NFT COMIC LAUNCH",
    blurb: "Koraxos comic drops with holder utility.",
  },
  {
    phase: "Q2 2025",
    title: "GAME ALPHA",
    blurb: "First playable vertical slice of open-world systems.",
  },
  {
    phase: "Q3 2025",
    title: "VR CITY PREVIEW",
    blurb: "Oshar districts and VR real estate experiences.",
  },
  {
    phase: "Q4 2025",
    title: "GAME BETA",
    blurb: "Expanded content, balance, and live events.",
  },
  {
    phase: "2026",
    title: "FULL LAUNCH",
    blurb: "Live service, marketplace, and seasonal chapters.",
  },
];
